import styled, { css } from "styled-components";
import { colors } from "../../../theme/theme";

interface Navigation {
	show: boolean;
}

export const Wrraper = styled.div`
	width: 100%;
	display: flex;
	background-color: ${colors.mainColors.white_lilac};
	overflow-x: hidden;

	#kitten-button {
		display: none;
	}

	.nav-total:hover {
		#kitten-button {
			display: flex;
		}
	}
`;

export const ContentPage = styled.div<Navigation>`
	margin-top: 70px;
	margin-left: ${({ show }) => (show ? "195px" : "70px")};
	width: 100%;

	@media (max-width: 900px) {
		margin-left: 0px;
		display: flex;
		margin-left: 0px;
	}
`;

export const Content = styled.div`
	background-color: white;
	padding: 30px;
	padding-bottom: 0px;
	padding-right: 0px;
	min-height: 90vh;
	height: 99%;
	width: 100%;
`;

export const ContentHeader = styled.div`
	color: ${colors.greyscale.darker_grey};
	font-size: 16px;
	border-bottom: 1px solid ${colors.greyscale.light_grey};

	.title {
		font-size: 26px;
	}

	.subtitle {
		font-size: 14px;
		padding-left: 15px;
	}
`;

export const ContentBody = styled.div`
	color: ${colors.greyscale.darker_grey};
	font-size: 16px;

	.p-dropdown .p-dropdown-label.p-placeholder {
		color: ${colors.greyscale.grey2};
	}
`;

export const PrimaryButton = styled.div`
	button {
		width: 100%;
		padding: 8px 16px;
		background-color: ${colors.mainColors.verde_dstore};
		border-radius: 4px;
		border: 1px solid ${colors.mainColors.verde_dstore};
		color: ${colors.greyscale.white};
	}
`;

export const DisabledButton = styled.div`
	button {
		width: 100%;
		padding: 8px 16px;
		background-color: ${colors.greyscale.grey};
		border-radius: 4px;
		border: 1px solid ${colors.greyscale.grey};
		color: ${colors.greyscale.white};
	}
`;

export const SecondaryButton = styled.div`
	button {
		width: 100%;
		padding: 5px;
		border-radius: 16px;
		background-color: ${colors.greyscale.white};
		border-radius: 4px;
		border: 1px solid ${colors.mainColors.verde_dstore};
		color: ${colors.mainColors.verde_dstore};
	}
`;

export const CardMaterialTitle = styled.div`
	padding: 10px 15px;
	/* background-color: ${colors.mainColors.blueberry}; */
	border-radius: 8px;
	box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);
	color: #28946e;
	font-size: 18px;
	font-weight: 700;

	&.material-item {
		/* background: ${colors.mainColors.verde_dstore} !important; */
	}

	&.material-theme {
		/* background: ${colors.mainColors.roxo_delinea} !important; */
	}

	&.material-media {
		/* background: ${colors.mainColors.capri} !important; */
	}
`;

export const CardDescription = styled.div`
	background-color: ${colors.greyscale.white};
	box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);
	padding: 15px;
	height: auto;
	color: ${colors.greyscale.darker_grey};
	border-radius: 8px;

	.title {
		font-weight: bold;
	}

	.card {
		border: none !important;
	}
`;

export const MultiSelectFilter = styled.div`
	.multiselect-dropdown {
		width: 100%;
		max-height: 40px;
		font-size: 14px;
	}

	.p-multiselect .p-multiselect-label.p-placeholder {
		color: ${colors.greyscale.grey2};
	}
`;

export const DropdownFilter = styled.div`
	.p-dropdown {
		width: 100%;
		max-height: 40px;
		font-size: 14px;
	}

	.p-dropdown .p-dropdown-label {
		padding: 10px;
	}
`;

export const ObjectsCategoryIcon = styled.em`
	color: ${colors.mainColors.blueberry};
	font-size: 21px;
	cursor: pointer;
	width: 20px;
`;

export const NotFound = styled.div`
	width: 100%;
	height: calc(100vh - 15em);
	text-align: center;
	vertical-align: center;
	font-size: 24px;
	margin-top: 25vh;
	color: ${colors.greyscale.grey};

	.iconNotFound {
		font-size: 14vh;
		color: ${colors.greyscale.grey2};
	}
`;

export const Kitten = styled.span<Navigation>`
	${({ show }) => css`
		cursor: pointer;
		position: fixed;
		width: 25px;
		height: 25px;
		border: 2px solid ${colors.mainColors.verde_dstore};
		border-radius: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 99;
		left: 58px;
		top: 80px;
		background: ${colors.mainColors.verde_dstore} !important;
		transition: all 0.3s linear;

		@media (max-width: 900px) {
			display: none !important;
		}

		svg {
			width: 15px !important;
			height: 15px !important;
			color: ${colors.greyscale.white} !important;
		}

		${show && wrapperModifiers.show()};
	`}
`;

const wrapperModifiers = {
	show: () => css`
		left: 197px;
		transition: all 0.3s linear;

		@media (max-width: 900px) {
			left: 85%;
			top: 5%;
		}
	`,
};
